<ui-grid [data]="data$ | async"
         [loading]="loading$ | async"
         class="ui-triggers-page-grid">
    <ui-grid-header [search]="true">
        <ui-header-button type="inline">
            <ng-template>
                <ui-grid-reset *ngIf="hasCustomFilters$ | async"
                               (reset)="resetFilter()"></ui-grid-reset>
            </ng-template>
        </ui-header-button>

        <ui-header-button type="main">
            <ng-template>
                <button [uiAuthorizeAllDisable]="['Schedules.Create', 'Processes.View']"
                        [matTooltip]="'grid_action_add' | translate"
                        [routerLink]="['add']"
                        uiClickTrack="Action: Add Trigger"
                        mat-mini-fab
                        color="primary"
                        data-cy="triggers-add"
                        type="button">
                    <mat-icon>add</mat-icon>
                </button>
            </ng-template>
        </ui-header-button>

        <ui-header-button type="action">
            <ng-template>
                <button [uiAuthorizeDisable]="'Schedules.Delete'"
                        [matTooltip]="'triggers_grid_action_remove' | translate"
                        (click)="removeItems()"
                        mat-icon-button
                        color="warn"
                        type="button">
                    <mat-icon svgIcon="uipath:Delete20px">
                    </mat-icon>
                </button>
            </ng-template>
        </ui-header-button>

        <ui-header-button type="action">
            <ng-template>
                <button [disableIf]="isEverySelectedEntryEnabled"
                        [class.loading]="loading$ | async"
                        [uiAuthorizeDisable]="'Schedules.Edit'"
                        [matTooltip]="'triggers_grid_action_disable' | translate"
                        (click)="setState(false)"
                        mat-icon-button
                        type="button">
                    <mat-icon svgIcon="uipath:TriggerDisable">
                    </mat-icon>
                </button>
            </ng-template>
        </ui-header-button>

        <ui-header-button type="action">
            <ng-template>
                <button [disableIf]="isEverySelectedEntryDisabled"
                        [class.loading]="loading$ | async"
                        [uiAuthorizeDisable]="'Schedules.Edit'"
                        [matTooltip]="'triggers_grid_action_enable' | translate"
                        (click)="setState(true)"
                        mat-icon-button
                        type="button">
                    <mat-icon svgIcon="uipath:TriggerEnable">
                    </mat-icon>
                </button>
            </ng-template>
        </ui-header-button>
    </ui-grid-header>

    <ui-grid-column [title]="'triggers_grid_state' | translate"
                    [resizeable]="false"
                    [visible]="false"
                    property="enabled">
        <ui-grid-dropdown-filter [items]="statusList"></ui-grid-dropdown-filter>
    </ui-grid-column>

    <ui-grid-column [title]="'triggers_grid_name' | translate"
                    [sortable]="true"
                    [searchable]="true"
                    [primary]="true"
                    property="name"
                    sort="asc"
                    width="19%">
        <ng-template let-entry="data">
            <mat-icon [matTooltip]="(entry.enabled ? 'GlobalFilter_Enabled' : 'GlobalFilter_Disabled') | translate"
                      [svgIcon]="entry.queueDefinitionId ? 'uipath:queueTrigger': 'uipath:timeTrigger'"
                      [attr.color]="entry.enabled ? 'success': 'inactive'">
            </mat-icon>
            <span [matTooltip]="entry.name">{{ entry.name }}</span>
        </ng-template>
    </ui-grid-column>

    <ui-grid-column [title]="'triggers_grid_process' | translate"
                    [sortable]="true"
                    [searchable]="true"
                    width="15%"
                    property="packageName">
    </ui-grid-column>

    <ui-grid-column [title]="'triggers_grid_environment' | translate"
                    [sortable]="true"
                    [searchable]="true"
                    property="environmentName"
                    width="15%">
    </ui-grid-column>

    <ui-grid-column [title]="'trigger_type' | translate"
                    [sortable]="true"
                    [searchable]="false"
                    property="queueDefinitionId"
                    width="6%">
        <ui-grid-dropdown-filter [items]="typeList"></ui-grid-dropdown-filter>

        <ng-template let-entry="data">
            <ng-container *ngLet="(
              entry.queueDefinitionId ?
                'trigger_type_Queue':
                'trigger_type_Time'
          ) | translate as triggerTypeKey">
                <span [matTooltip]="triggerTypeKey">{{ triggerTypeKey }}</span>
            </ng-container>
        </ng-template>
    </ui-grid-column>

    <ui-grid-column [title]="'triggers_grid_trigger_details' | translate"
                    [sortable]="false"
                    [primary]="true"
                    property="startProcessCronSummary"
                    width="20%">
        <ng-template let-entry="data">
            <ng-container *ngIf="entry.queueDefinitionName; else timeTriggerInfo">
                <span [matTooltip]="'queue_trigger_linked_to' | translate: { queue: entry.queueDefinitionName }">
                    {{ entry.queueDefinitionName }}
                </span>
            </ng-container>
            <ng-template #timeTriggerInfo>
                {{ entry.startProcessCronSummary }}
            </ng-template>
        </ng-template>
    </ui-grid-column>

    <ui-grid-column [title]="'triggers_grid_next_run_time' | translate"
                    [sortable]="false"
                    [primary]="true"
                    property="startProcessNextOccurrence"
                    width="15%">
        <ng-template let-index="index"
                     let-entry="data">
            <mat-icon *ngIf="entry.enabled"
                      [matTooltip]="entry.timezoneIana"
                      [style.opacity]="entry.timezoneIana === currentTimezone ? 0.4 : 1"
                      svgIcon="uipath:Clock">
            </mat-icon>
            <ng-container *ngIf="entry.enabled">
                <ui-dateformat #dateFormat
                               *ngIf="!entry.queueDefinitionId; else notApplicable"
                               [matTooltip]="dateFormat.dataset['title']"
                               [date]="entry.startProcessNextOccurrence"
                               [timezone]="entry.timezoneIana"
                               dateFormat="L LTS (Z)"
                               contentType="relative"></ui-dateformat>
            </ng-container>
            <span *ngIf="!entry.enabled"
                  [matTooltip]="'GlobalFilter_Disabled' | translate"
                  translate>GlobalFilter_Disabled</span>
        </ng-template>
    </ui-grid-column>

    <ui-grid-column [title]="'triggers_grid_stop_after' | translate"
                    [sortable]="false"
                    property="stopProcessExpression"
                    width="10%">
        <ng-template let-entry="data">
            <ui-secondformat #secondFormat
                             *ngIf="!entry.queueDefinitionId; else notApplicable"
                             [matTooltip]="secondFormat.innerText"
                             [seconds]="entry.stopProcessExpression">
            </ui-secondformat>
        </ng-template>
    </ui-grid-column>

    <ui-grid-row-action>
        <ng-template let-index="index"
                     let-entry="data">
            <button [uiAuthorizeAnyDisable]="['Jobs.View', 'Schedules.Edit', 'Schedules.Delete']"
                    [matMenuTriggerFor]="menu"
                    [matTooltip]="'global_more_actions_tooltip' | translate"
                    data-cy="grid-action-menu"
                    mat-icon-button
                    type="button">
                <mat-icon svgIcon="uipath:More">
                </mat-icon>
            </button>
            <mat-menu #menu="matMenu">
                <button [disableIf]="entry.queueDefinitionId && !(hasQueuesViewPermission$ | async) ||
                                     entry.startStrategy === 0 && !(hasRobotsViewPermission$ | async)"
                        [uiAuthorizeAllDisable]="['Schedules.Edit', 'Processes.View']"
                        [routerLink]="[entry.id, 'edit']"
                        mat-menu-item
                        uiClickTrack="Action: Grid: Edit"
                        data-cy="edit-trigger"
                        type="button">
                    <mat-icon svgIcon="uipath:Edit">
                    </mat-icon>
                    {{ 'triggers_grid_action_edit' | translate }}
                </button>
                <a [routerLink]="[entry.id, 'jobs']"
                   [uiAuthorizeDisable]="'Jobs.View'"
                   mat-menu-item>
                    <mat-icon svgIcon="uipath:ViewLogs">
                    </mat-icon>
                    {{ 'triggers_grid_action_view_jobs' | translate }}
                </a>
                <a *ngIf="entry.queueDefinitionId"
                   [routerLink]="['/queues', entry.queueDefinitionId]"
                   [uiAuthorizeAllDisable]="['Queues.View','Queues.Edit']"
                   mat-menu-item>
                    <mat-icon svgIcon="uipath:Edit">
                    </mat-icon>
                    {{ 'triggers_grid_action_edit_queue' | translate }}
                </a>
                <button [disableIf]="entry.enabled"
                        [class.loading]="loading$ | async"
                        [uiAuthorizeDisable]="'Schedules.Edit'"
                        (click)="setState(true, entry.id)"
                        mat-menu-item
                        uiClickTrack="Action: Grid: Enable"
                        data-cy="enable-trigger"
                        type="button">
                    <mat-icon svgIcon="uipath:TriggerEnable">
                    </mat-icon>
                    {{ 'triggers_grid_action_enable' | translate }}
                </button>
                <button [disableIf]="!entry.enabled"
                        [class.loading]="loading$ | async"
                        [uiAuthorizeDisable]="'Schedules.Edit'"
                        (click)="setState(false, entry.id)"
                        mat-menu-item
                        uiClickTrack="Action: Grid: Disable"
                        data-cy="disable-trigger"
                        type="button">
                    <mat-icon svgIcon="uipath:TriggerDisable">
                    </mat-icon>
                    {{ 'triggers_grid_action_disable' | translate }}
                </button>
                <button [uiAuthorizeDisable]="'Schedules.Delete'"
                        (click)="removeItems([entry])"
                        mat-menu-item
                        color="warn"
                        uiClickTrack="Action: Grid: Remove"
                        data-cy="remove-trigger"
                        type="button">
                    <mat-icon svgIcon="uipath:Delete">
                    </mat-icon>
                    {{ 'triggers_grid_action_remove' | translate }}
                </button>
            </mat-menu>
        </ng-template>
    </ui-grid-row-action>

    <ui-grid-footer [length]="total$ | async"
                    [pageSize]="pageSize"
                    [pageSizes]="pageSizes">
    </ui-grid-footer>
</ui-grid>

<ng-template #notApplicable>
    {{ 'global_n_a_label' | translate }}
</ng-template>
